import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaPhone } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function FloatingCTA() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.8);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm border-t border-gray-200 dark:border-slate-700 px-4 py-3 flex items-center gap-3 shadow-lg">
      <Link
        to="/#contact"
        className="flex-1 btn bg-teal-600 hover:bg-teal-700 border-teal-600 hover:border-teal-700 text-white rounded-lg text-center py-2.5 font-medium"
      >
        {t('CTA.requestDemo')}
      </Link>
      <a
        href="tel:+59892516901"
        className="btn btn-icon bg-teal-600 hover:bg-teal-700 border-teal-600 hover:border-teal-700 text-white rounded-lg"
        aria-label={t('CTA.discussUseCase')}
      >
        <FaPhone />
      </a>
    </div>
  );
}
